export const AUTH_SESSION_DATE_KEY = "uptaskAuthSessionDate";

export const getLocalDateKey = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const markAuthSessionStarted = () => {
  localStorage.setItem(AUTH_SESSION_DATE_KEY, getLocalDateKey());
};

export const isAuthSessionCurrent = () =>
  localStorage.getItem(AUTH_SESSION_DATE_KEY) === getLocalDateKey();

export const clearAuthSessionDate = () => {
  localStorage.removeItem(AUTH_SESSION_DATE_KEY);
};
